import React from 'react';

const PlanChip = ({ jobPlan, idRequired = false }) => {
  if (!jobPlan) {
    return null;
  }

  const { subscription_name,  user_plan_id, is_premium } = jobPlan;
  
  const formattedPlanId = user_plan_id ? user_plan_id.toString().padStart(5, '0') : '00000';
  
  const chipStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 8px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: '500',
    margin: '2px',
    backgroundColor: is_premium === '1' ? '#ECE6F4' : 'rgba(0, 139, 138, 0.12)',
    color: is_premium === '1' ? '#682FA3' : '#008B8A',
    border: 'none',
    marginLeft: '0px'
  };

  const planIdStyles = {
    color: '#A19A9A',
    marginLeft: '4px'
  };

  return (
    <>
      <span style={chipStyles}>
        {subscription_name}
        {idRequired && <span style={planIdStyles}>• Plan ID: {formattedPlanId}</span>}
      </span>
    </>
  );
};

export default PlanChip;
